<template>
  <div class="maintenance-item">
    <div class="maintenance-item-update">
      <div class="title-line">
        <div class="title-name">{{ historyItem.name }}</div>
        <div class="posted-at">
          {{ historyItemStart }}
        </div>
      </div>
      <nl2br tag="div" class-name="message" :text="historyItem.description"/>
    </div>
  </div>
</template>
<script>

import Nl2br from 'vue-nl2br'
import getUserLocale from 'get-user-locale'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

export default {
  components: {
    Nl2br
  },
  props: {
    historyItem: {
      required: true,
      type: Object
    },
    statusPageLanguage: {
      required: false,
      type: Object
    }
  },

  computed: {
    historyItemStart () {
      const userTz = dayjs.tz.guess() // e.g., "Asia/Tokyo"
      const sourceTz = this.historyItem.timezone?.utc?.[0] || 'UTC'
      const startStr = this.historyItem.start // e.g., "2025-06-18 09:30:00"

      // 1. Parse date in original maintenance timezone
      const startInSourceTz = dayjs.tz(startStr, 'YYYY-MM-DD HH:mm:ss', sourceTz)
      // 2. Convert to user's local time
      const localTime = startInSourceTz.tz(userTz)

      // 3. Format using Intl
      const locale = this.statusPageLanguage?.date_and_time_language?.type ?? getUserLocale()

      const formatter = new Intl.DateTimeFormat(locale, {
        month: 'short',
        day: '2-digit',
        hour: 'numeric',
        minute: 'numeric'
      })

      return formatter.format(localTime.toDate())
    }
  }
}
</script>
<style scoped>
.maintenance-item {
  padding: 30px;
  background: #f8f8f8;
  border-radius: 8px;
  margin-bottom: 20px;

  .maintenance-item-update {
      @media (max-width: 500px) {
        font-size: 16px;
      }
    }

    .title-line {
      display: flex;
      margin-bottom: 10px;
      align-items: center;

      @media (max-width: 360px) {
        display: block;
      }

      .title-name {
        font-weight: 600;
        margin-right: 10px;
        max-width: 405px;
      }

      .posted-at {
        font-weight: 500;
        font-size: 14px;
        color: rgba(25, 34, 29, 0.5);
        white-space: nowrap;
      }
    }
  }
</style>
